import React from 'react'
import { connect } from 'react-redux'
import UpdateBtnModal from './UpdateBtnModal'
import { AppState, ImageConfig } from '../reducers'

const INFO = 'Aktualizuj asortyment'
const UPDATING = 'Trwa aktualizacja...'
const ERROR = 'Aktualizacja nieudana'

interface UpdateBtnState {
    showModal: boolean
    waiting: boolean
    success: boolean
    text: string
}

class UpdateBtn extends React.Component<ReturnType<typeof mapStateToProps>, UpdateBtnState> {
    closeModal
    openModal

    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            waiting: false,
            success: true,
            text: INFO
        }

        this.closeModal = () => {
            this.setState({ showModal: false })
        }

        this.openModal = () => {
            this.setState({ showModal: true })
        }
    }

    buildImagePosition(image: ImageConfig, patternImage: ImageConfig) {
        if (patternImage !== null) {
            return {
                fileName: image.fileName,
                img_pos: {
                    x: patternImage.img_pos.x,
                    y: patternImage.img_pos.y,
                    z: patternImage.img_pos.z
                }
            }
        } else {
            return {
                fileName: image.fileName,
                img_pos: {
                    x: image.img_pos.x,
                    y: image.img_pos.y,
                    z: image.img_pos.z
                }
            }
        }
    }

    sendPositions() {
        if (this.state.waiting) return
        this.setState({ waiting: true, success: false, text: UPDATING })

        let { utils, serverUrl, filteredAssortment } = this.props
        let url = serverUrl + utils
        let positions = filteredAssortment.products

        const xmlhttp = new XMLHttpRequest()
        xmlhttp.open("POST", url)
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
        let positionsJSON = JSON.stringify(positions)
        xmlhttp.send('rynny-update-positions=' + positionsJSON)

        xmlhttp.onreadystatechange = () => {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    if (xmlhttp.responseText === 'success') {
                        this.setState({ waiting: false, success: true, text: INFO })
                    } else {
                        this.setState({ waiting: false, success: false, text: ERROR })
                    }
                } else {
                    this.setState({ waiting: false, success: false, text: ERROR })
                }
            }
        }
    }

    render() {
        return (
            <div>
                <button disabled={this.state.waiting} id="kr-btn" onClick={this.openModal}>
                    {this.state.waiting ?
                        <div
                            className="kr-spinner"
                            style={{
                                height: "15px",
                                width: "15px",
                                border: "6px solid #f3f3f3",
                                borderTop: "6px solid #3498db"
                            }}>
                        </div> : null
                    }
                    <span>{this.state.text}</span>
                </button>
                <UpdateBtnModal
                    show={this.state.showModal}
                    closeModal={this.closeModal}
                    sendPositions={() => {this.sendPositions()}}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    serverUrl: state.config.serverUrl,
    utils: state.config.utils,
    filteredAssortment: state.filteredAssortment
})

export default connect(mapStateToProps)(UpdateBtn)
